export class InitialQuotation {
    constructor({
        documentType = null,
        documentNumber = null,
        cellphone = null,
        email = null,
        birthDate = null,
        firstSurname = null,
        lastSurname = null,
        names = null,
        nationality = null,
        recaptchaToken = null,
        clientType = null,
        whichEnsure = null,
        housingType = null,
        contactConsent = false,
    } = {}) {
        this.documentType = documentType;
        this.documentNumber = documentNumber;
        this.cellphone = cellphone;
        this.email = email;
        this.birthDate = birthDate;
        this.firstSurname = firstSurname;
        this.lastSurname = lastSurname;
        this.names = names;
        this.nationality = nationality;
        this.recaptchaToken = recaptchaToken;
        this.clientType = clientType;
        this.whichEnsure = whichEnsure;
        this.housingType = housingType;
        this.contactConsent = contactConsent;
    }
}
